import { createContext } from "react";

export const StaticContext = createContext<{ statusCode?: number }>({});
